import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { createLogger } from 'redux-logger';
import * as thunk from 'redux-thunk';
import rootReducer from './reducers';
import tracking from './tracking/middleware';

const configureStore = (initialState = {}) => {
    const middleware = [thunk.thunk, tracking];

    if (process.env.NODE_ENV === 'development') {
        middleware.push(
            createLogger({
                level: 'info',
                collapsed: true,
            })
        );
    }

    const store = createStore(rootReducer, initialState, applyMiddleware(...middleware));

    // TODO ?

    // if (module.hot) {
    //     module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
    // }

    return store;
};

export default configureStore;
